export default __webpack_public_path__ + "static/media/expPurple.96a6bf63.svg";